import React from 'react';
import '../styles/employee-profile-workspace.css';

const SectionPlaceholder = ({ title, description }) => {
  return (
    <section className="employee-workspace__placeholder">
      <div className="employee-workspace__placeholderInner">
        <h2 className="employee-workspace__placeholderTitle">{title}</h2>
        <p className="employee-workspace__placeholderText">{description}</p>
      </div>
    </section>
  );
};

export default SectionPlaceholder;
